<template>
  <div
    class="TransactionList">
    <CRUDList
      :canEdit="true"
      :canSave="true"
      :headers="headers"
      :showDate="true"
      :showTotal="true"
      :displayTopPagination="false"
      :hide-default-footer="true"
      :disable-pagination="true"
      :baseCrudKey="baseCrudKey"
      toolbarTitle="SA&I Summary"
      @upsertItem="upsrtTransaction"
      :headersWithColsSpan= "subHeaders"
    >
      <template v-slot:[`editedItem`]="{}">
        <SaiMonthlySummaryEditedItem
        :baseCrudKey="baseCrudKey"
        />
      </template>
      <template v-slot:[`additionalToolsAtRight`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            :disabled="!isDisabledMonthlyReportBtn"
            id="saiMonthlySummaryListPrintMonthlyReportBtn"
            class="sai-monthly-summaryList-print-monthly-report-btn"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openMonthlyReport"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
            Monthly Report
          </v-btn>
          </template>
            <span>Monthly Report</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            id="saiYearlySummaryListPrintYearlyReportBtn"
            class="sai-yearly-summaryList-print-yearly-report-btn"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openYearlyReport"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
            Yearly Report
          </v-btn>
          </template>
            <span>Yearly Report</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            id="saiYearlySummaryListPrintFinancialReportBtn"
            class="sai-yearly-summaryList-print-financial-report-btn"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openFinancialReport"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
            Financial Report
          </v-btn>
          </template>
            <span>Financial Report</span>
        </v-tooltip>
         <v-divider
          class="mx-4" inset vertical
        ></v-divider>
         <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="glDailyTranLisTLockBtn"
              class="glDaily-translist-lock-icon"
              color="primary"
              v-bind="attrs"
              v-on="on"
              fab icon small
              :disabled = !isButtonLock
              @click="saiSummaryRecordLock"           >
              <v-icon>
                {{ icons.mdiLockOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>Lock</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              id="glDailyTranListUnlockBtn"
              class="glDaily-translist-unlock-icon"
              color="primary"
              fab icon small
               :disabled="isButtonUnLock"
              @click="saiSummaryUnlockRecords"
            >
              <v-icon>
                {{ icons.mdiLockOpenVariantOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>Unlock</span>
        </v-tooltip>
      </template>
    </CRUDList>
  </div>
</template>
<script>
import {
  mdiPrinter,
  mdiLockOutline,
  mdiLockOpenVariantOutline,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { amountToNumber } from '../../../../util/shared/vue-global';
import { toIsoDate } from '../../../../util/shared/tmc-global';
import CRUDList from '../../../common/base/crud/CRUDList.vue';
import SaiMonthlySummaryEditedItem from './SaiMonthlySummaryEditedItem.vue';
import { queryStringCalcForReports } from '../report.util';
import { getRawJwt } from '../../../../util/jwt';
import { clients } from '../../../../util/clients';

const saiSummaryFields = ['month', 'year', 'summaryDetailsGLBanks', 'summaryDetailsGLFunds', 'bankTotalFromGL', 'fundTotalFromGL', 'odTotalMonthlySummary', 'glBankMonthlySummary', 'glFundMonthlySummary'];
const { backendRest } = clients.direct;
const getHeaders = () => {
  const headers = [
    {
      text: 'G/L Banks', value: 'summaryDetailsGLBanks', formatter: 'amount', align: 'right',
    },
    {
      text: 'G/L Funds', value: 'summaryDetailsGLFunds', formatter: 'amount', align: 'right',
    },
    {
      text: 'Bank Total', value: 'bankTotalFromGL', formatter: 'amount', align: 'right', enableLine: true, class: 'with-divider-left',
    },
    {
      text: 'Fund Total', value: 'fundTotalFromGL', formatter: 'amount', align: 'right',
    },
    {
      text: 'OD Total', value: 'odTotalMonthlySummary', formatter: 'amount', align: 'right', enableLine: true, class: 'with-divider-left',
    },
    {
      text: 'GL Bank', value: 'glBankMonthlySummary', formatter: 'amount', align: 'right',
    },
    {
      text: 'GL Fund', value: 'glFundMonthlySummary', formatter: 'amount', align: 'right',
    },
    { text: 'Message', value: 'message' },
    { text: 'Lock Date ', value: 'lockDate' },
    { text: 'Un Usable', value: 'isUnUsable', formatter: 'boolToStr' },
  ];
  return headers;
};
export default {
  data: () => ({
    headers: [],
    baseCrudKey: 'saiMonthlySummary',
    icons: {
      mdiPrinter,
      mdiLockOutline,
      mdiLockOpenVariantOutline,
    },
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    subHeaders: {
      mainHeadName:
                [
                  {
                    text: '',
                    cols: '4',
                    id: 1,
                  },
                  {
                    text: 'Official Depository',
                    cols: '3',
                    id: 2,
                  },
                  {
                    text: '',
                    cols: '2',
                    id: 3,
                  },
                ],
    },
  }),
  created() {
    this.headers = getHeaders();
  },
  components: {
    CRUDList,
    SaiMonthlySummaryEditedItem,
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapState({
      isSaiMonthlySummaryLocked: (state) => state.glDaily.saiMonthlySummaryTransaction.isLocked,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getAuthToken() {
      return getRawJwt();
    },
    queryStringForSaiMonthly: {
      cache: false,
      get() {
        return queryStringCalcForReports({
          criteria: this.criteriaState,
          token: this.getAuthToken,
          isSaiMonthly: true,
          isReportPrint: false,
        });
      },
    },
    queryStringForSaiYearly() {
      return queryStringCalcForReports({
        criteria: this.criteriaState,
        token: this.getAuthToken,
        isSaiMonthly: false,
        isReportPrint: true,
      });
    },
    isDisabledMonthlyReportBtn() {
      const items = this.items(this.baseCrudKey) || [];
      return this.criteriaState.fiscalYear != null && this.criteriaState.monthyear != null
      && items.length !== 0;
    },
    isButtonUnLock() {
      const result = this.isSaiMonthlySummaryLocked;
      return result;
    },
    isButtonLock() {
      const items = this.items(this.baseCrudKey) || [];
      if (items.length > 0) {
        const result = this.isSaiMonthlySummaryLocked;
        return result;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('glDaily/saiMonthlySummaryTransaction', [
      'loadSaiMonthlySummary',
      'upsertSaiMonthlySummary',
    ]),
    async upsrtTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      saiSummaryFields.forEach((f) => {
        updatedItem[f] = amountToNumber(updatedItem[f]);
      });
      const response = await this.upsertSaiMonthlySummary({ item: updatedItem, baseCrudKey });
      return response;
    },
    openMonthlyReport() {
      const toUrl = `${backendRest.defaults.baseURL}/gl/sai/transactions/saiMonthly${this.queryStringForSaiMonthly}`;
      window.open(toUrl);
    },
    openYearlyReport() {
      const toUrl = `${backendRest.defaults.baseURL}/gl/sai/transactions/saiYearly${this.queryStringForSaiYearly}`;
      window.open(toUrl);
    },
    openFinancialReport() {
      const toUrl = `${backendRest.defaults.baseURL}/gl/sai/transactions/saiFinancial${this.queryStringForSaiYearly}`;
      window.open(toUrl);
    },
    saiSummaryRecordLock() {
      const { fiscalYear, monthyear } = this.criteriaState;
      const { month, year } = monthyear;
      if (fiscalYear != null && month != null) {
        const confirmationMessage = `This will lock the record/s for the year ${year} month ${this.months[month - 1]}!`;
        if (window.confirm(confirmationMessage)) {
          const items = this.items(this.baseCrudKey) || [];
          items[0].isLocked = this.isSaiMonthlySummaryLocked;
          items[0].lockDate = toIsoDate(new Date());
          this.upsrtTransaction(items[0]);
        }
      }
    },
    saiSummaryUnlockRecords() {
      const { monthyear } = this.criteriaState;
      const { month, year } = monthyear;
      const confirmationMessage = `This will unlock the record/s for the year ${year} month ${this.months[month - 1]}`;
      if (window.confirm(confirmationMessage)) {
        const items = this.items(this.baseCrudKey) || [];
        items[0].isLocked = this.isSaiMonthlySummaryLocked;
        items[0].lockDate = null;
        this.upsrtTransaction(items[0]);
      }
    },
  },
};
</script>
<style>
.saiMonthlySummaryHeader {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
